<template>
  <div class="box-second">
    <p class="title-crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right color3">
        <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
        <el-breadcrumb-item>班组信息</el-breadcrumb-item>
      </el-breadcrumb>
    </p>
    <div class="main">
      <div class="main-left">
        <p class="main-left-p">
          <span>共{{ entList.length }}个参建单位</span>
          <el-button size="mini" type="primary" icon="el-icon-plus" @click="addEntFun">添加</el-button>
        </p>
        <div class="main-left-list">
          <ul>
            <li v-for="item in entList" :key="item.projectEntId" :class="{'curEnt':joinEntId==item.projectEntId}"
                @click="getEntId(item)">
              <div class="unit-type">
                {{ item.label }}
              </div>
              <div class="unit-name color4">
                <p :title="item.entName" class="nowrap">{{ item.entName }}</p>
                <p><i class="el-icon-s-custom"></i> {{ item.personCount }}人</p>
              </div>
              <div class="unit-ctl" style="width:10%;" @click.stop="delEnt(item)" v-if="isMenuExit('pro:proent:del')">
                <i class="el-icon-delete" style="color:red"></i>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="main-table">
        <div class="box-ent">
          <div class="box-ent-l">
            <p class="nowrap" :title="entInfo.entName">参建单位名称：{{ entInfo.entName }}</p>
            <p class="nowrap" :title="entInfo.joinType">参建单位类型：{{ entInfo.label }}</p>
            <p class="nowrap" :title="entInfo.creditCode">统一社会信用代码：{{ entInfo.creditCode }}</p>
            <p class="nowrap" :title="entInfo.personName">联系人：{{ entInfo.personName }}</p>
            <p class="nowrap" :title="entInfo.personPhone">联系电话：{{ entInfo.personPhone }}</p>
          </div>
          <div class="box-ent-r">
            <!-- <el-button type="primary" icon="el-icon-edit" @click="modEnt(entInfo)">修改</el-button>
             -->
            <!-- <div @click="open" class="jm-btn" style="margin-right:0.6vw">解密</div> -->
            <el-tooltip class="item" effect="dark" content="分包单位信息" placement="top-end"
                        v-if="isMenuExit('pro:join:subinfo')">
              <el-button type="primary" icon="el-icon-postcard" size="mini" @click="addInfo(entInfo)"
                         style="margin-right:1vw;"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="修改参建单位" placement="top-end">
              <img @click="modEnt(entInfo)" class="icon_hover" src="../../assets/image/edit.png" alt="" srcset="">
            </el-tooltip>
          </div>
        </div>
        <div class="table-head">
          <div class="table-head-seach" style="top: -1vh;">
            <el-input autocomplete="off" placeholder="请输入班组名称" v-model="teamName" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
            </el-input>
          </div>
          <!-- <el-button type="primary" size="mini" plain icon="el-icon-plus" @click="addTeam">添加班组</el-button> -->
          <el-tooltip class="item" effect="dark" content="添加班组" placement="top-end" v-if="isMenuExit('pro:team:add')">
            <img @click="addTeam" class="icon_hover" src="../../assets/image/addTeam.png" alt="" srcset="">
          </el-tooltip>
        </div>
        <div class="table-box">
          <el-table :data="tableDataEnd" height="100%" style="width: 100%"
                    :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
            <template slot="empty">
              <p>{{ dataText }}</p>
            </template>
            <el-table-column label="序号" type="index" width="80"></el-table-column>
            <el-table-column label="班组名称">
              <template slot-scope="scope">
                <!-- <router-link :to="'/teamWorker/'+scope.row.id" class="color5" :title="scope.row.name">{{scope.row.name}}</router-link> -->
                <span class="color5" style="cursor: pointer;" @click="toTema(scope.row)">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="班组类型">
              <template slot-scope="scope">
                <span>{{ getNameById(scope.row.teamsType) }}</span>
                <!-- <span v-if="scope.row.teamsType=='1'">工人</span>
                <span v-else-if="scope.row.teamsType=='3'">特种</span>
                <span v-else-if="scope.row.teamsType==''"></span>
                <span v-else>管理人员</span> -->
              </template>
            </el-table-column>
            <el-table-column label="班组人数">
              <template slot-scope="scope">
                <span>{{ scope.row.num }}人</span>
              </template>
            </el-table-column>
            <el-table-column label="班组长">
              <template slot-scope="scope">
                <span>{{ scope.row.managerName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="电话号码">
              <template slot-scope="scope">
                <span>{{ scope.row.managerTel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" width="200">
              <template slot-scope="scope">
                <span>{{ scope.row.createDate }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button size="mini" v-if="isMenuExit('pro:team:edit') && scope.row.name!='未分配班组'"
                           @click="handleEdit(scope.$index, scope.row)" v-show="psw!=''">编辑
                </el-button>
                <el-button size="mini" v-if="isMenuExit('pro:team:del')" type="danger"
                           @click="handleDelete(scope.$index, scope.row)">删除
                </el-button>
              </template>
            </el-table-column>

            <!-- 新增窗口 -->
            <el-dialog
                :title="diaTitle"
                :visible.sync="addFormVisible"
                center
                :append-to-body="true"
                :lock-scroll="false"
                width="30%"
                :close-on-click-modal="false"
            >
              <el-form
                  :model="addForm"
                  ref="addForm"
                  label-width="150px"
                  label-position="right"
                  class="teamPage"
                  :rules="teamRules"
              >
                <el-form-item label="班组名称" prop="name">
                  <el-input v-if="addForm.jgStatus!='2'" v-model="addForm.name" autocomplete="off"></el-input>
                  <p v-else>{{ addForm.name }}<span style="color:#F56C6C;">(上传监管平台，无法修改)</span></p>
                  <!-- <el-input v-else v-model="addForm.name" autocomplete="off" style="width:220px"></el-input> -->
                </el-form-item>
                <el-form-item label="班组类型：" prop="teamsType">
                  <el-select v-if="addForm.jgStatus!='2'" v-model="addForm.teamsType" placeholder="请选择">
                    <el-option
                        v-for="item in teamTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                  </el-select>
                  <p v-else>{{ addForm.teamsTypeName }}<span style="color:#F56C6C;">(上传监管平台，无法修改)</span></p>
                </el-form-item>
                <!-- <el-form-item label="参建单位：" prop="projectEntId">
                    <el-select
                    v-if="addForm.id==''"
                    v-model="addForm.projectEntId"
                    clearable
                    filterable
                    placeholder="请选择"
                    >
                    <el-option
                        v-for="item in ents"
                        :key="item.id"
                        :label="'('+item.typeName+')'+item.entName"
                        :value="item.id"
                    ></el-option>
                    </el-select>
                    <p v-else>{{'('+addForm.joinTypeName+')'+addForm.entName}}</p>
                </el-form-item> -->
                <el-form-item label="班组长：">
                  <el-select
                      v-model="addForm.teamManager"
                      clearable
                      filterable
                      @change="changeManagerFun"
                      placeholder="请选择"
                  >
                    <el-option
                        v-for="item in teamPersons"
                        :key="item.personId"
                        :label="item.name+'('+item.idcard+')'"
                        :value="item.personId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系电话：">
                  <el-input v-model="addForm.managerTel" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注：">
                  <el-input
                      v-model="addForm.remarks"
                      type="textarea"
                      placeholder="请输入内容"
                      autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="addFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
              </div>
            </el-dialog>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 新增参建单位窗口 -->
    <el-dialog
        :title="entTitle"
        :visible.sync="entVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        width="28%"
        :close-on-click-modal="false"
    >
      <el-form
          :model="addEnt"
          ref="addEnt"
          :rules="rules"
          label-width="150px"
          label-position="right"
          class="joinEnt"
      >
        <el-form-item label="统一信用社代码：" prop="creditCode">
          <el-input
              v-if="addEnt.id==''"
              v-model="addEnt.creditCode"
              autocomplete="off"
              @change="getEnvFun"
          ></el-input>
          <p v-else>{{ addEnt.creditCode }}</p>
        </el-form-item>
        <el-form-item label="单位名称：" prop="entName">
          <el-input
              v-if="addEnt.id==''"
              v-model="addEnt.entName"
              autocomplete="off"
          ></el-input>
          <p v-else>{{ addEnt.entName }}</p>
        </el-form-item>
        <el-form-item label="注册地名称：" v-if="this.groupId=='1534350540559794178'">
          <el-input v-model="addEnt.registrationAddr" type="textarea" :rows="2" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="注册地编码：" v-if="this.groupId=='1534350540559794178'">
          <el-cascader
              :props="{value:'id',label:'name'}"
              :options="areas"
              v-model="registrationAddr"
              change-on-select="true"
          ></el-cascader>
<!--          <el-input v-model="addEnt.registrationAddr" autocomplete="off"></el-input>-->
        </el-form-item>
        <el-form-item label="单位类型：" prop="joinType">
          <el-select v-if="addEnt.id==''" v-model="addEnt.joinType" placeholder="请选择">
            <el-option
                v-for="item in entsTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
          <p v-else>{{ addEnt.label }}</p>
        </el-form-item>
        <el-form-item label="单位联系人：">
          <el-input v-model="addEnt.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" >
          <el-input v-model="addEnt.phone" autocomplete="off"></el-input>
        </el-form-item>
<!--        nihao-->
<!--        <el-form-item label="行政区划代码：" v-if="this.groupId=='1534350540559794178'">-->
<!--          <el-input v-model="addEnt.areaId" autocomplete="off"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="组织机构代码："  v-if="this.groupId=='1534350540559794178'">
          <el-input v-model="addEnt.organizationCode" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="税号：" v-if="this.groupId=='1534350540559794178'">
          <el-input v-model="addEnt.taxIdnumber" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系姓名：" v-if="this.groupId=='1534350540559794178'">
          <el-input v-model="addEnt.contacts" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱：" v-if="this.groupId=='1534350540559794178'">
          <el-input v-model="addEnt.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="项目经理：" v-if="this.groupId=='1534350540559794178'">
          <el-input v-model="addEnt.manager" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="项目经理联系电话：" v-if="this.groupId=='1534350540559794178'">
          <el-input v-model="addEnt.managerPhone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="现场负责人：" v-if="this.groupId=='1534350540559794178'">
          <el-input v-model="addEnt.principal" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="负责人电话：" v-if="this.groupId=='1534350540559794178'">
          <el-input v-model="addEnt.principalPhone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话：" v-if="this.groupId=='1534350540559794178'">
          <el-input v-model="addEnt.contactsPhone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号：" v-if="this.groupId=='1534350540559794178'">
          <el-input v-model="addEnt.taxpayerNumber" autocomplete="off"></el-input>
        </el-form-item>
<!--        nihao-->
        <el-form-item label="法人：">
          <el-input v-model="addEnt.legalPerson" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="法人联系电话：">
          <el-input v-model="addEnt.legalPersonPhone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="所在区域：">
          <el-cascader
              :props="{value:'id',label:'name'}"
              :options="areas"
              v-model="addEntArea"
              change-on-select="true"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址：">
          <el-input v-model="addEnt.address" type="textarea" :rows="2" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="公章：">
          <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :headers="uploadHead"
              :data="uploadData"
          >
            <img v-if="showImg" :src="showImg" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="entVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddEnt('addEnt')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="提示"
        :visible.sync="pswShow"
        width="30%">
      <div style="text-align:left;margin-bottom:6px">请输入解密密码！</div>
      <el-input
          placeholder="请输入密码"
          v-model="pswVal"
          show-password
          autocomplete="new-password"></el-input>
      <span slot="footer" class="dialog-footer">
                <el-button @click="pswShow = false">取 消</el-button>
                <el-button type="primary" @click="decrypt">确 定</el-button>
            </span>
    </el-dialog>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'

export default {
  data() {
    var checkphone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入手机号'))
      } else if (!this.isCellPhone(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('请输入正确的手机号!'))
      } else {
        callback()
      }
    }
    var code = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入统一信用社代码'))
      } else if (!this.checkCode(value)) {
        callback(new Error('请输入正确的统一信用社代码!'))
      } else {
        callback()
      }
    }
    return {
      showImg: '',
      imgData: {},
      uploadUrl: base.url + '/upload/uploadPhoto', //图片上传地址
      uploadHead: {
        accessToken: this.$store.state.token,
      },
      uploadData: {
        type: 252,
      },
      psw: '',
      registrationAddr:[],
      pswVal: '',
      pswShow: false,
      entName: '',//参建单位查询
      groupId: '',
      entList: [],//参建单位list
      entsTypes: [],//参建单位类型list
      entTitle: '',//参建单位弹出框名称
      entVisible: false,
      persons: [],//参建单位的管理人员
      addEnt: {
        corporateSeal: '',
        id: '',
        joinType: '1',
        creditCode: '',
        entName: '',
        entId: '',
        email:'',
        name: '',
        phone: '',
        legalPerson: '',//法人
        legalPersonPhone: '',//法人联系方式
        areaId: '',//区域
        address: '',//详情地址
        domicileCode: '',
        organizationCode:'',
        taxIdnumber:'',
        contacts:'',
        manager:'',
        managerPhone:'',
        principal:'',
        principalPhone:'',
        contactsPhone:'',
        taxpayerNumber:'',
        registrationCode:'',
        registrationAddr:''
      },
      areas: [],//所有的区域
      addEntArea: [],//参建单位区域选择
      rules: {
        // creditCode: [
        // { required: true, validator: code, trigger: 'blur' }
        // ],
        entName: [
          {required: true, message: '请输入单位名称', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请选择单位联系人', trigger: 'blur'}
        ],
        phone: [{required: true, validator: checkphone, trigger: 'blur'}] //validator: checkphone是验证手机的引入checkphone函数
      },
      joinEntId: '',//当前展示参建企业
      //////////////////////////////////////////////////
      tableDataEnd: [],//班组列表
      diaTitle: '添加班组',//班组添加名称
      teamTypes: [
        {label: '工人', value: '1'},
        {label: '管理人员', value: '2'},
        {label: '特种', value: '3'}
      ],
      addFormVisible: false,//班组添加弹出框
      teamRules: {
        name: [{required: true, message: '请输入班组名称', trigger: 'blur'}],
        teamsType: [
          {required: true, message: '请选择班组类型', trigger: 'blur'}
        ],
        projectEntId: [
          {required: true, message: '请选择参建单位', trigger: 'blur'}
        ],
        // managerTel: [{ required: true, validator: checkphone, trigger: 'blur' }] //validator: checkphone是验证手机的引入checkphone函数
      },
      dataText: '数据加载中...',
      addForm: {
        id: '',
        name: '',
        teamsType: '1',
        creditCode: '',
        remarks: '',
        projectEntId: '',
        teamManager: '',
        managerTel: ''
      },
      teamName: '',//班组名称
      teamPersons: [],//班组人员
      entInfo: {
        joinType: '',
        creditCode: '',
        personName: '',
        personPhone: '',
        id: '',
        legalPerson: '',//法人
        legalPersonPhone: '',//法人联系方式
        areaId: '',//区域
        address: '',//详情地址
        corporateSeal: '',
        entName: '',
        entId: '',
        email:'',
        name: '',
        phone: '',
        domicileCode: '',
        organizationCode:'',
        taxIdnumber:'',
        contacts:'',
        manager:'',
        managerPhone:'',
        principal:'',
        principalPhone:'',
        contactsPhone:'',
        taxpayerNumber:'',
        registrationCode:'',
        registrationAddr:''
      },
    }
  },
  mounted() {
    util.common.filterBtnMenu('')
    var port = util.session.get('roleId')
    if (port == '4') {
      this.groupId = util.session.get('groupId')
    } else if (port == '5' || port == '3') {
      this.groupId = util.session.get('proId')
    }
    this.getTeamType()
    this.getJoinType()
    this.getPerson()
    this.getArea()
  },
  methods: {
    decrypt() {
      this.psw = this.pswVal
      this.getJoinEnt()
      this.pswShow = false
    },
    open() {
      this.pswVal = ''
      this.pswShow = true
    },
    //获取班组类型
    getTeamType() {
      var that = this
      myHttp.getDictByType({
        type: 'team_type'
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.dictList || []
          that.teamTypes = list
        }
      })
    },
    //根据类型获取名称
    getNameById(val) {
      var result = ''
      for (var i = 0; i < this.teamTypes.length; i++) {
        if (this.teamTypes[i].value == val) {
          result = this.teamTypes[i].label
        }
      }
      return result
    },
    //获取参建单位
    getJoinEnt() {
      var that = this
      myHttp.getProjectEntByProjectId({
        projectId: this.groupId,
        userId: util.session.get('user').id,
        password: this.psw
      }).then(function (resp) {
        // console.log(resp,'424')
        if (resp.data.code == '200') {
          var list = resp.data.data.projectEnt || []
          if (list.length > 0) {
            if (that.joinEntId == '') {
              that.joinEntId = list.length > 0 ? list[0].projectEntId : ''
              that.entInfo = list[0]
            } else {
              for (var i = 0; i < list.length; i++) {
                if (that.joinEntId == list[i].projectEntId) {
                  that.entInfo = list[i]
                }
              }
            }
            that.getData()
          } else {
            that.dataText = '暂无数据'
          }
          that.entList = list
          console.log(that.entList,'/that')
        } else {
          that.$message.error(resp.data.msg)
          that.psw = ''
          that.getJoinEnt()
        }
      })
    },
    //获取参建单位类型
    getJoinType() {
      var that = this
      myHttp.getDictByType({
        type: 'join_type'
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.dictList || []
          that.entsTypes = list
        }
        that.getJoinEnt()
      })
    },

    //根据id获取名称
    getTypeName(id) {
      var list = this.entsTypes
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    //查询参建数据
    entFilter() {
      this.getJoinEnt()
    },
    //添加参建单位
    addEntFun() {
      // console.log('imgdata--->',this.imgData);
      this.showImg = ''//打开添加单位弹窗时置空公章回显数据以及之前的公章路径
      this.imgData = ''
      this.entVisible = true
      this.addEnt =
      //     {
      //   corporateSeal: '',
      //   id: '',
      //   joinType: '1',
      //   creditCode: '',
      //   entName: '',
      //   entId: '',
      //   phone: '',
      //   personId: '',
      //   legalPerson: '',
      //   legalPersonPhone: '',
      //   areaId: '',
      //   address: ''
      // }
      {
        corporateSeal: '',
            id: '',
          joinType: '1',
          creditCode: '',
          entName: '',
          entId: '',
          email:'',
          name: '',
          phone: '',
          legalPerson: '',//法人
          legalPersonPhone: '',//法人联系方式
          areaId: '',//区域
          address: '',//详情地址
          domicileCode: '',
          organizationCode:'',
          taxIdnumber:'',
          contacts:'',
          manager:'',
          managerPhone:'',
          principal:'',
          principalPhone:'',
          contactsPhone:'',
          taxpayerNumber:'',
          registrationCode:'',
          registrationAddr:''
      }
      this.addEntArea = []
      this.registrationAddr=[]
      this.entTitle = '添加参建单位'
    },
    //获取管理人员
    getPerson() {
      var that = this
      myHttp.selectProjectPersonInfoList({
        projectId: this.groupId
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.entity || []
          that.persons = list
          that.teamPersons = list
        }
      })
    },
    //获取关联企业id
    getEnvFun() {
      var that = this
      myHttp.getAllEnt({
        creditCode: this.addEnt.creditCode
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var data = resp.data.data.entList && resp.data.data.entList[0]
          if (data) {
            that.addEnt.entName = data.name
            that.addEnt.entId = data.id
          } else {
            that.addEnt.entId = ''
          }
        }
      })
    },
    //检查手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false
      } else {
        return true
      }
    },
    //查查统一信用代码
    checkCode(val) {
      if (!/^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g.test(val)) {
        return false
      } else {
        return true
      }
    },
    //监听人员选择
    changePerson() {
      var id = this.addEnt.personId
      var list = this.persons
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].personId) {
          this.addEnt.phone = list[i].phone
        }
      }
    },
    //添加或者修改参建单位
    sumbitAddEnt(formName) {
      var that = this
      this.addEnt.corporateSeal = this.imgData
      this.addEnt.userId = util.session.get('user').id
      this.addEnt.projectId = this.groupId
      this.addEnt.areaId = this.addEntArea.length > 0 ? this.addEntArea[this.addEntArea.length - 1] : ''
      this.addEnt.registrationCode =this.registrationAddr.length > 0? this.registrationAddr[this.registrationAddr.length - 1] : ''
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.addEnt.id == '') {
            myHttp.createProjectEnt(this.addEnt).then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('添加成功')
                that.entVisible = false
                that.getJoinEnt()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          } else {
            myHttp.updateProjectEnt(this.addEnt).then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('修改成功')
                that.entVisible = false
                that.getJoinEnt()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          }
        } else {
          //console.log('error submit!!')
          return false
        }
      })
    },
    //选择展示的参建企业
    getEntId(row) {
      this.joinEntId = row.projectEntId
      this.entInfo = row
      this.getData()
    },

    /***
     * 获取班组
     */
    getData() {
      var that = this
      // console.log(this.joinEntId)
      myHttp.getTeams({
        projectEntId: this.joinEntId,
        projectId: this.groupId,
        name: this.teamName,
        userId: util.session.get('user').id,
        password: this.psw
      }).then(function (resp) {
        console.log(resp, '623')
        if (resp.data.code == '200') {
          that.tableDataEnd = resp.data.data.pageInfo || []
          if (that.tableDataEnd.length == 0) {
            that.dataText = '暂无数据'
          }
        } else {
          that.$message.error(resp.data.msg)
          that.psw = ''
          that.dataText = '暂无数据'
        }
      })
    },
    /**
     * 根据名称查询班组
     */
    doFilter() {
      this.getData()
    },
    /**
     * 添加班组
     */
    addTeam() {
      this.addFormVisible = true
      this.teamPersons = []
      this.getPerson()
      this.addForm = {
        id: '',
        name: '',
        teamsType: '1',
        creditCode: '',
        remarks: '',
        projectEntId: this.joinEntId,
        teamManager: '',
        managerTel: '',
        jgStatus: '',
      }
      this.diaTitle = '添加班组'
    },
    //修改班组
    handleEdit(index, row) {
      // console.log(row)
      this.addFormVisible = true
      this.persons = []
      // this.getPersonByTeam(row.id)
      this.getPerson()
      this.addForm.id = row.id
      this.addForm.projectEntId = row.projectEntId
      this.addForm.name = row.name
      this.addForm.teamsType = row.teamsType
      if (row.teamsType == '1') {
        this.addForm.teamsTypeName = '工人'
      } else if (row.teamsType == '2') {
        this.addForm.teamsTypeName = '管理人员'
      } else if (row.teamsType == '3') {
        this.addForm.teamsTypeName = '特种'
      } else {
        this.addForm.teamsTypeName = ''
      }
      this.addForm.creditCode = row.creditCode
      this.addForm.entName = row.entName
      this.addForm.entId = row.entId
      this.addForm.remarks = row.remarks
      this.addForm.teamManager = row.teamManager
      this.addForm.managerTel = row.managerTel
      this.addForm.joinTypeName = row.joinTypeName
      this.addForm.deviceSn = row.deviceSn
      this.addForm.jgStatus = row.jgStatus
      this.diaTitle = '班组修改'
    },
    // 删除班组
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            myHttp
                .delTeams({
                  id: row.id
                })
                .then(function (resp) {
                  if (resp.data.code == '200') {
                    that.$message({
                      type: 'success',
                      message: '删除成功!'
                    })
                    that.getData()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                })
          })
          .catch(err => {
          })
    },
    //获取班组人员
    getPersonByTeam(id) {
      var that = this
      myHttp.selectProjectPersonInfoList({
        teamsId: id,
        projectId: this.groupId
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.entity || []
          that.teamPersons = list
        }
      })
    },
    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.addForm.userId = this.$store.state.user.id
      this.addForm.projectId = this.groupId
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.addForm.id == '') {
            myHttp.createTeams(this.addForm).then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('添加成功')
                that.addFormVisible = false
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          } else {
            myHttp.updateTeams(this.addForm).then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('修改成功')
                that.addFormVisible = false
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          }
        } else {
          //console.log('error submit!!')
          return false
        }
      })
    },
    //监听班组长判断
    changeManagerFun(e) {
      this.addForm.personId = e
      var id = this.addForm.teamManager
      var list = this.teamPersons
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].personId) {
          this.addForm.managerTel = list[i].phone
        }
      }
    },
    //修改参建单位
    modEnt(row) {
      console.log(row,'rowrow')
      this.entTitle = '参建单位修改'
      if (row.corporateSeal) {
        // 回显公章时如果有公章数据就赋值到回显变量
        this.showImg = base.httpCtx + row.corporateSeal
      } else if (!row.corporateSeal) {
        // 否则置空
        this.showImg = ''
      }
      //  this.showImg=base.httpCtx+row.corporateSeal
      this.addEnt.corporateSeal = row.corporateSeal
      // this.showImg=base.httpCtx+row.private
      this.addEnt.id = row.projectEntId
      this.addEnt.projectEntId = row.projectEntId
      this.addEnt.joinType = row.joinType
      this.addEnt.label = row.label
      this.addEnt.creditCode = row.creditCode
      this.addEnt.entName = row.entName
      this.addEnt.entId = row.entId
      this.addEnt.name = row.personName
      this.addEnt.phone = row.personPhone
      this.addEnt.legalPerson = row.legalPerson
      this.addEnt.legalPersonPhone = row.legalPersonPhone
      this.addEnt.areaId = row.areaId
      this.addEnt.address = row.address
      this.addEnt.organizationCode=row.organizationCode
      this.addEnt.taxIdnumber=row.taxIdnumber
      this.addEnt.contacts=row.contacts
      this.addEnt.manager=row.manager
      this.addEnt.managerPhone=row.managerPhone
      this.addEnt.principal=row.principal
      this.addEnt.principalPhone=row.principalPhone
      this.addEnt.contactsPhone=row.contactsPhone
      this.addEnt.taxpayerNumber=row.taxpayerNumber
      this.addEnt.registrationAddr=row.registrationAddr
      this.addEnt.registrationCode=row.registrationCode
      this.addEnt.email=row.email
      this.entVisible = true
      this.addEntArea = []
      this.registrationAddr=[]
      this.setAreaFun(row.areaId)
      this.setAreaFun2(row.registrationCode)
      console.log(this.addEnt)
    },
    //
    toTema(row) {
      var port = util.session.get('roleId')
      if (port == '4') {
        this.$router.push({path: '/teamWorker/' + row.id})
      } else if (port == '5' || port == '3') {
        this.$router.push({path: '/teamWorkerCom/' + row.id})
      }
    },
    /**
     * 判断是否展示
     */
    isMenuExit(row) {
      var flag = util.common.filterBtnMenu(row)
      return flag
    },
    /**
     * 删除参建单位
     */
    delEnt(row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.delProEntById({
          id: row.projectEntId
        }).then(function (resp) {
          if (resp.data.code == '200') {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
            if (that.joinEntId == row.projectEntId) {
              that.joinEntId = ''
              that.getJoinEnt()
            } else {
              that.getJoinEnt()
            }
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      }).catch(err => {
      })
      //joinEntId==item.projectEntId
    },

    //添加或者编辑信息
    addInfo(row) {
      this.$router.push({path: '/joinEntInfo/' + row.projectEntId})
    },

    //获取区域
    getArea() {
      var that = this
      myHttp.getAreaList().then(
          function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.areaList
              var tree = util.common.listToTree('id', 'parentId', list)
              that.areas = tree
              console.log(that.areas,'thatthis')
            } else {
              that.$message.error(resp.data.msg)
            }
          }, function () {

          })
    },
    //回显区域
    setAreaFun(id) {
      console.log('修改')
      if ('' == id || undefined == id) return
      var that = this
      myHttp.getAreaById({
        id: id
      }).then(function (resp) {
            if (resp.data.code == '200') {
              var province = resp.data.data.area.provinceId
              var city = resp.data.data.area.cityId
              var area = resp.data.data.area.countyId
              if (resp.data.data.area.level == '3' && undefined == area) {
                area = resp.data.data.area.id
              }
              var arry = []
              arry.push(province)
              arry.push(city)
              arry.push(area)
              that.addEntArea = arry
            }
          },
          function (error) {

          })
    },
    setAreaFun2(id) {
      console.log('xiugai')
      if ('' == id || undefined == id) return
      var that = this
      myHttp.getAreaById({
        id: id
      }).then(function (resp) {
            if (resp.data.code == '200') {
              console.log('xiugai2')
              var province = resp.data.data.area.provinceId
              var city = resp.data.data.area.cityId
              var area = resp.data.data.area.countyId
              if (resp.data.data.area.level == '3' && undefined == area) {
                area = resp.data.data.area.id
              }
              var arry = []
              arry.push(province)
              arry.push(city)
              arry.push(area)
              that.registrationAddr = arry
            }
          },
          function (error) {

          })
    },
    handleAvatarSuccess(data) {
      if (data.code == 200) {
        console.log(data.data);
        this.imgData = data.data.saveUrls
        this.showImg = base.httpCtx + this.imgData
        console.log(this.showImg);
        console.log('----->', this.imgData);
      }
    }
  }

}
</script>
<style scoped>

.main-left {
  width: 15vw;
  height: 100%;
  position: relative;
  /* overflow: auto; */
  background: #fff;
  border-radius: 0.5vh;
}

.main-left-search {
  width: 100%;
  height: 10%;
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  padding: 1vh;
}

.main-left-p {
  width: 100%;
  height: 10%;
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  padding: 0 1vh;
}

.main-left-list {
  width: 100%;
  height: 90%;
  position: relative;
  overflow: auto;
}

.main-left-list li {
  width: 100%;
  height: 15%;
  position: relative;
  padding: 2vh;
  display: flex;
  align-content: center;
  align-items: center;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.main-left-list li:hover {
  background: #eee;
}

.curEnt {
  background: #E7F1FB;
}

.unit-type {
  width: 20%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-content: center;
  border: 1px solid #0365F2;
  padding: 1.5%;
}

.unit-name {
  width: 70%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  align-content: center;
  padding-left: 1vh;
  flex-wrap: wrap;
}

.unit-name p {
  width: 100%;
  text-align: left;
}

.main-table {
  width: calc(100% - 15vw);
  height: 100%;
  position: relative;
  padding-left: 1vw;
  display: flex;
  flex-wrap: wrap;
}

.table-head {
  width: 100%;
  height: 6vh;
  position: relative;
  background: #fff;
  border-top-left-radius: 0.5vh;
  border-top-right-radius: 0.5vh;
  display: flex;
  align-content: center;
  align-items: center;
  padding: 2vh;
  justify-content: space-between;
}

.table-head-seach {
  width: 20%;
  height: 100%;
  position: relative;
}

.table-box {
  width: 100%;
  height: calc(100% - 17vh);
  position: relative;
  background: #fff;
  border-bottom-left-radius: 0.5vh;
  border-bottom-right-radius: 0.5vh;
}

.box-ent {
  width: 100%;
  height: 10vh;
  position: relative;
  margin-bottom: 1vh;
  background: #fff;
  border-radius: 5px;
  display: flex;
  /* flex-wrap: wrap; */
}

.box-ent-l {
  width: 80%;
  height: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding: 2vh;
  align-content: center;
  align-items: center;
}

.box-ent-l p {
  width: 33%;
  height: 3vh;
  position: relative;
  text-align: left;
  padding-right: 1vh;
}

.box-ent-r {
  width: 20%;
  height: 100%;
  display: flex;
  align-content: center;
  align-items: center;
  margin-right: 20px;
  justify-content: flex-end
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
<style>
@import '../../assets/css/common.css';
</style>